import { createSelector } from 'reselect';

import { IIntState } from '../../../../modules/internationalization/intReducer';
import { selectInt } from '../../../../modules/internationalization/intSelectors';

/*
* -------------------------------------------
*               Translation
* -------------------------------------------
*/

export const additionalAccountsTranslationSelector = () =>
    createSelector(
        selectInt,
        (state: IIntState) => state.translation.pageSubscriberId.tabs.additionalAccounts,
    );
